module.exports = __webpack_public_path__ + "static/media/sslv2.749eb01f.png";